// src/pages/CarDesign.js
import React from "react";
import styled from "styled-components";
import shelby1 from "../images/cardesign/shelby1.png";
import SEO from "../components/SEO";

const ArticleWrapper = styled.div`
  max-width: 800px;
  margin: auto;
  padding: 2rem;
  overflow-y: auto;

  @media only screen and (max-width: 768px) {
    padding: 1rem;
  }
`;

const Title = styled.h2`
  text-align: center;
  color: #004d99;

  @media only screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: #333;

  @media only screen and (max-width: 768px) {
    font-size: 0.95rem;
    line-height: 1.5;
  }
`;

const Img = styled.img`
  width: 100%;
  margin: 1rem 0;
  border-radius: 8px;
`;

const CarDesign = () => (
  <ArticleWrapper>
    <SEO
      title="Car Design Chapters — Airbag, Ignition, Fuel Injection, ECUs"
      description="Educational chapters on car component design and troubleshooting — airbags, ignition, fuel injection, onboard computers."
    />
    <Title>Car Design Chapters</Title>
    <Paragraph>
      Welcome to the Car Design guide. This section explores various automotive
      components and innovations — from ignition systems to onboard computers.
      Use the buttons on the right to dive into each chapter.
    </Paragraph>
    <Img src={shelby1} alt="Airbag Sensor Diagram" />
  </ArticleWrapper>
);

export default CarDesign;
